import React from "react";
import { BRAND } from "../lib/api";

export default function About() {
  return (
    <div className="section-container py-16 sm:py-24 max-w-4xl">
      <div className="eyebrow mb-3">About Lume Enterprise</div>
      <h1 className="font-serif text-4xl sm:text-5xl text-white leading-tight">The quiet standard of<br/><span className="italic text-[color:var(--lume-gold-light)]">private ground travel.</span></h1>
      <p className="mt-8 text-slate-300 leading-relaxed text-lg">
        Lume Enterprise was built around a single conviction: that the moment you step into your car should feel like the calmest part of your day.
      </p>
      <p className="mt-6 text-slate-400 leading-relaxed">
        Every chauffeur wears a suit, holds a commercial license, and passes rigorous background and driving screenings. Every vehicle is professionally detailed before it meets you and inspected between every ride. Every itinerary is monitored in real-time — from flight arrival to final drop-off — by a live concierge.
      </p>
      <p className="mt-6 text-slate-400 leading-relaxed">
        We serve executives moving between boardrooms, families on their way to milestone celebrations, travelers weary from the airport, and productions requiring absolute discretion. Whatever the reason for the ride, our promise is the same: precision, presence, and perfect quiet.
      </p>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          { k: "Vetted", v: "Every chauffeur individually interviewed & background-cleared." },
          { k: "Detailed", v: "Cabins sanitized and professionally detailed before every ride." },
          { k: "Monitored", v: "Live concierge tracks each trip end-to-end, 24/7." },
        ].map((s) => (
          <div key={s.k} className="lume-card p-6">
            <div className="font-serif text-xl text-white">{s.k}</div>
            <div className="text-sm text-slate-400 mt-2 leading-relaxed">{s.v}</div>
          </div>
        ))}
      </div>

      <div className="mt-14 lume-card p-8">
        <div className="eyebrow mb-3">Contact</div>
        <div className="text-slate-300"><strong>Phone:</strong> {BRAND.phone}</div>
        <div className="text-slate-300 mt-1"><strong>Email:</strong> {BRAND.email}</div>
      </div>
    </div>
  );
}
